import Api from "../apiService";

class VehicleDocumentsApi {
  options(companyId) {
    return Api.getRequest(
      `companies/${companyId}/vehicle_documents/options`,
      {},
      Api.authHeaders()
    );
  }

  indexAll(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/vehicle_documents`,
      params,
      Api.authHeaders()
    );
  }

  index(companyId, vehicleId) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, vehicleId, data) {
    return Api.postRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents/${id}`,
      data,
      Api.authHeaders()
    );
  }

  destroy(companyId, vehicleId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents/${id}`,
      Api.authHeaders()
    );
  }

  archive(companyId, vehicleId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents/${id}/archive`,
      {},
      Api.authHeaders()
    );
  }

  restore(companyId, vehicleId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents/${id}/restore`,
      {},
      Api.authHeaders()
    );
  }

  setCurrent(companyId, vehicleId, id) {
    return Api.postRequest(
      `companies/${companyId}/vehicles/${vehicleId}/documents/${id}/set_current`,
      {},
      Api.authHeaders()
    );
  }
}

export default new VehicleDocumentsApi();
